import React from "react";

const UserDetailsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45.734"
      height="33.83"
      viewBox="0 0 45.734 33.83"
    >
      <g id="db54" transform="translate(-179.913 -182.452)">
        <path
          id="Path_1322"
          data-name="Path 1322"
          d="M372.72,512.57h14.991v3.244H372.72Z"
          transform="translate(-192.807 -299.532)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1743"
          data-name="Path 1743"
          d="M372.72,512.57h14.991v3.244H372.72Z"
          transform="translate(-162.064 -299.532)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1323"
          data-name="Path 1323"
          d="M372.72,210.76h23.2V214h-23.2Z"
          transform="translate(-170.269 -24.999)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1324"
          data-name="Path 1324"
          d="M198.332,184.528v14.266a2.076,2.076,0,0,1-2.076,2.076H181.99a2.076,2.076,0,0,1-2.076-2.076V184.528a2.076,2.076,0,0,1,2.076-2.076h14.266A2.08,2.08,0,0,1,198.332,184.528Z"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1325"
          data-name="Path 1325"
          d="M372.72,283.97h14.991v3.244H372.72Z"
          transform="translate(-170.269 -89.652)"
          fill={fill ? fill : "#ff7eb5"}
        />
        <path
          id="Path_1327"
          data-name="Path 1327"
          d="M372.72,439.36h45.732V442.6H372.72Z"
          transform="translate(-192.807 -234.879)"
          fill={fill ? fill : "#ff7eb5"}
        />
      </g>
    </svg>
  );
};

export default UserDetailsIcon;
